import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SECURE_API = (process.env.REACT_APP_API_SECURE=="true" ? "s" : "");
const API_URL = (process.env.REACT_APP_API_URL || window.location.hostname + ":" + window.location.port + "/api/v1");
const RELOAD_URL = "/auth/reload";

const AppContext = createContext();

const ReloadQueu = [];

function AppProvider({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    const [maintenance, setMaintenance] = useState({up: false, time: null});
    const [socket, setSocket] = useState(null);


    useEffect(() => {    
        function connect() {
            const ws = new WebSocket("ws" + SECURE_API +"://" + API_URL + "/ws");
            setSocket(ws);

            ws.onopen = () => {
                ws.send(JSON.stringify({ type: "hello" }));
            };

            ws.onmessage = (msg) => {
                const data = JSON.parse(msg.data);
                switch(data.type) {
                    case "maintenance":
                        setMaintenance(data.content);
                        break;
                    case "ping":
                        send("pong", {}, ws);
                }
            }

            ws.onclose = (ev) => {
                setTimeout(connect, 5000);
            }
        }

        function send(type, content, ws) {
            ws.send(JSON.stringify({type: type, content: content}));
        }

        connect();
    }, []);

    const send = (endpoint, method, token, body, callback = (data) => {}, refresh = false) => {
        if(!endpoint.startsWith("/")) {
            endpoint = "/" + endpoint;
        }

        const url = "http" + SECURE_API + "://" + API_URL + endpoint;
        let headers = {};
        if(!emptyCheck(token)) {
            headers.Authorization = "bearer " + token;
        }

        if(!emptyCheck(body))
            headers["Content-Type"] = "application/json";

        fetch(url, {
            method: method,
            headers: headers,
            body: JSON.stringify(body)
        }).then(response => {
            if(response.status == 401 && !refresh) {
                ReloadQueu.push({endpoint: endpoint, method: method, body: body, callback: callback});
                return reload();
            }

            if(response.status == 403) {
                return expire();
            }

            const contentType = response.headers.get("content-type");

            if(contentType && contentType.includes("application/json"))
                response.json().then(data => {
                    callback(data);
                });
            else {
                callback(response);
            }
        });
    };

    const sendGet = (endpoint, callback) => {
        send(endpoint, "GET", localStorage.getItem("access_token"), undefined, callback);
    };

    const sendPost = (endpoint, body, callback) => {
        send(endpoint, "POST", localStorage.getItem("access_token"), body, callback);

    };

    const setTokens = (accessToken, refreshToken) => {
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem("refresh_token", refreshToken);
    };

    const reloadToken = (callback) => {
        if(emptyCheck(localStorage.getItem("refresh_token")))
            return callback(false);
    
        send(RELOAD_URL, "POST", localStorage.getItem("refresh_token"), {access_token: localStorage.getItem("access_token")}, (data) => {
            if(data.next == -1)
                setTokens(data.access_token, data.refresh_token)
    
            callback(data.next == -1);
        }, true);
    };

    let reloadInUse = false;

    const reload = (callback) => {     
        if(reloadInUse)
            return;

        reloadInUse = true;
        
        reloadToken(success => {
            reloadInUse = false;
            if(success) {
                while(ReloadQueu.length > 0) {
                    let data = ReloadQueu.shift();
                    send(data.endpoint, data.method, localStorage.getItem("access_token"), data.body, data.callback, true);
                }
                if(callback !== undefined)
                    callback();
            }else {
                expire();
            }
        });
    };

    const expire = () => {
        logout();

        navigate("/expire", { replace: true });
    };

    const logout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
    };

    const  emptyCheck = (val) => {
        return val == undefined || val == null || val == "" || val == [] || val == {};
    };

    const emptyChecks = (array, vals) => {
        if(emptyCheck(array))
            return true;

        for(let v of vals)
            if(emptyCheck(array[v]))
                return true;

        return false;
    };

    /**
     * 
     * @returns -1: expire, 0: no token, 1: valide
     */
    const isLogin = () => {
        const tokenExist = !emptyCheck(localStorage.getItem("access_token")) && !emptyCheck(localStorage.getItem("refresh_token"));
        if(!tokenExist)
            return 0;

        const exp = tokenPayload()?.exp * 1000;
        let date = new Date().getTime();
    
        if(exp - date >= 0) 
            return 1;
        else
            return -1;
    };

    const tokenPayload = () => {
        if(emptyCheck(localStorage.getItem("access_token")) || localStorage.getItem("access_token").split(".").length != 3)
            return {};
        return JSON.parse(decodeURIComponent(atob(localStorage.getItem("access_token").split(".")[1]).split("").map(c => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")).join("")));
    }

    const getPrivilegeLevel = () => {
        let ret = tokenPayload()?.level;        
        return ret==undefined?-1:ret;
    };

    return (
        <AppContext.Provider value={{
            navigate,
            location,
            send,
            sendGet,
            sendPost,
            setTokens,
            reloadToken,
            reload,
            logout,
            emptyCheck,
            emptyChecks,
            isLogin,
            tokenPayload,
            getPrivilegeLevel,
            maintenance
        }}>
            {children}
        </AppContext.Provider>
    )
}

export default AppProvider;

export const useApp = () => {
    return useContext(AppContext);
};